import React from 'react';
import '../LandingPage/LandingPage.css';
import Footer from '../../Components/Footer/FooterSmall';
import InputForm from './Form';
import Header2 from '../../Components/Header2/Header2';

const UserInfo: React.FC = () => {
  return (
    <div className='generalPage'>
      <Header2/>
      <div className='landingPage'>
        {/* <div className={header.headerContainer}>
          <Header />
        </div> */}
        <InputForm />
      </div>
      <Footer />
    </div>

  );
};

export default UserInfo;